import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from '@mui/material';
export const NavigationSkeleton = () => _jsx(Skeleton, { variant: "rounded", height: "1.5em", sx: { marginBlock: '3px' } });
